
import React from 'react'
import classNames from 'classnames'
import defaultHeaderConfig from '../../../config/navigation/navbar/uk/new-nav'
import defaultAlertsTranslationConfig from '../../../config/components/alerts/uk'
import defaultLoginConfig from '../../../config/navigation/login/uk'
import HeaderNav from './nav/new-navbar.jsx'
import LoginNav from './nav/loginNav.jsx'
import SearchForm from './searchForm.jsx'
import LoggedInUser from './nav/loggedInUser.jsx'
import ReduxStores from '../../../stores/connects'
import BookingsDropdown from './homepage/bookingsDropdown.jsx'
import HarpAlert from './harp-alert.jsx'
import DiscountAlert from './discount-alert.jsx'
import Helpers from '../../../../_plugins/lib/helpers'
import { object, bool, string, array, func } from 'prop-types'
import WelcomeBackMsg from './welcomeBackMsg'
const SHOW_WELCOME_BACK_MSG_TIME = 4000
const HIDE_WELCOME_BACK_MSG_TIME = 10000

class Nav extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      activeTab: '',
      collapseMenu: true,
      welcomeBackMsgVisible: false
    }
    this.handleCollapseMenu = this.handleCollapseMenu.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.closeWelcomeBackMsg = this.closeWelcomeBackMsg.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showWelcomeBackMsg && nextProps.loggedInData.hasOwnProperty('email') && !Helpers.getCookie('welcomeBackMsgAlreadyShown') && !this.showWelcomeBackMsgTimeout) {
      this.showWelcomeBackMsgTimeout = setTimeout(() => {
        this.setState({ welcomeBackMsgVisible: true })
        this.hideWelcomeBackMsgTimeout = setTimeout(() => {
          this.closeWelcomeBackMsg()
        }, HIDE_WELCOME_BACK_MSG_TIME)
      }, SHOW_WELCOME_BACK_MSG_TIME)
    }
  }

  componentWillUnmount() {
    if (this.showWelcomeBackMsgTimeout) clearTimeout(this.showWelcomeBackMsgTimeout)
    if (this.hideWelcomeBackMsgTimeout) clearTimeout(this.hideWelcomeBackMsgTimeout)
  }

  shouldComponentUpdate (nextProps, nextState) {
    if (nextProps.loggedInData) return true
    if (nextState.collapseMenu !== this.state.collapseMenu) return true
    if (nextState.activeTab !== this.state.activeTab) return true
    if (nextState.welcomeBackMsgVisible !== this.state.welcomeBackMsgVisible) return true
    return false
  }

  componentDidUpdate () {
    this.scrollIntoViewIfNeeded()
  }

  closeWelcomeBackMsg() {
    this.setState({ welcomeBackMsgVisible: false })
    Helpers.setCookie('welcomeBackMsgAlreadyShown', true)
  }

  // https://stackoverflow.com/a/37829643/1134191
  scrollIntoViewIfNeeded () {
    try {
      const target = document.querySelectorAll('#header .navbar-collapse li.open.dropdown')
      if (target.length) {
        const rect = target[0].getBoundingClientRect()
        if (rect.top < 0) target[0].scrollIntoView()
      }
    } catch (e) {}
  }

  handleCollapseMenu (e) {
    if (e && e.preventDefault) e.preventDefault()
    this.setState(prevState => ({
      collapseMenu: !prevState.collapseMenu
    }))
  }

  handleClick (activeTab) {
    if (!activeTab) activeTab = ''
    this.setState({
      activeTab
    })
  }

  getLoginConfig () {
    if (!this.props.loginConfig) return defaultLoginConfig
    return this.props.loginConfig
  }

  getHeaderConfig () {
    if (!this.props.headerConfig) return defaultHeaderConfig
    return this.props.headerConfig
  }

  getAlertsTranslationConfig () {
    if (!this.props.alertsTranslationConfig) return defaultAlertsTranslationConfig
    return this.props.alertsTranslationConfig
  }

  getGreeting (mobileGreeting = false) {
    const { showStrapLineText, noPersonalisation, tradeMark, isHomepage, loggedInData = {} } = this.props
    let tradeMarkHtml = ''
    if (tradeMark) {
      tradeMarkHtml = '<span class="trade-mark">&trade;</span>'
    }
    if (noPersonalisation || !loggedInData.first_name) return showStrapLineText + tradeMarkHtml
    const time = new Date()
    let dayTime = 'Evening'
    if (time.getHours() < 18) dayTime = 'Afternoon'
    if (time.getHours() < 12) dayTime = 'Morning'
    if (!isHomepage || mobileGreeting) return `<span>Good ${dayTime}, ${loggedInData.first_name}</span>`
    else return `${showStrapLineText} <span class="user-span">for ${loggedInData.first_name} ${loggedInData.last_name}</span>`
  }

  getBookingButton () {
    const { loggedInData, showBookingsButton, pageData: { pageName } } = this.props
    if (!showBookingsButton || !loggedInData.first_name) return null
    return (<BookingsDropdown pageName={pageName} />)
  }

  render () {
    const { loggedInData = {}, domainSettings, includeAlerts, settings, pageData, phoneNumbers = {}, hideLinks, authenticationConfig, showStrapLineText, showBookingsButton, showSearchForm, phoneNumberOverride, showAppLink, appSettings, isHomepage, phoneNumberText, showH1Tag, mobilePhoneBanner, discludeMenuItems, showHideDiscountBanner, showHideHarpBanner, showWelcomeBackMsg, conceptEngineActive, conceptEngineSettings } = this.props
    const { activeTab, collapseMenu, welcomeBackMsgVisible } = this.state
    const loginConfig = this.getLoginConfig()
    const phoneNumber = phoneNumberOverride || phoneNumbers.number
    const { pageName } = pageData
    const loggedInStatus = loggedInData.hasOwnProperty('email')
    const alertsTranslationConfig = this.getAlertsTranslationConfig()

    const containerClass = classNames({
      'navbar': true,
      'navbar-default': true,
      'navbar-static-top': true,
      'hidden-print': true,
      'navbar-megamenu': true,
      'navbar-concept': conceptEngineActive
    })

    const headingClass = classNames({
      'pull-left': true,
      'h2': !conceptEngineActive,
      'h1': conceptEngineActive
    })

    const collapsedMenu = classNames({
      'collapse': collapseMenu,
      'navbar-collapse': true
    })
    const buttonClasses = classNames({
      'btn': true,
      'btn-sm': conceptEngineActive,
      'pull-right': conceptEngineActive,
      'nav-cta-button': true,
      'btn-success': true,
      'noBookings': (!loggedInStatus || !showBookingsButton) && !conceptEngineActive
    })
    const phoneNumberClass = classNames({
      'pull-right': true,
      'phoneNumber': true,
      'visible-xs': !phoneNumberOverride && !mobilePhoneBanner,
      'hidden-xs': mobilePhoneBanner
    })
    const headerConfig = this.getHeaderConfig()
    const bookingButton = this.getBookingButton()

    let customPhoneText = phoneNumberText ? (
      <span>{phoneNumberText}<br /></span>
    ) : ''

    const conceptLogo = conceptEngineSettings.logo

    return (
      <nav id='header' className={containerClass} role='navigation'>
        <div className='container'>
          <div className='navbar-header'>
            { !hideLinks && (
              <button type='button' className='navbar-toggle hidden-sm hidden-md hidden-lg' data-hxtrack-name='mobile-navbar' onClick={this.handleCollapseMenu}>
                <span className='sr-only'>Toggle navigation</span>
                <span className='icon-bar' />
                <span className='icon-bar' />
                <span className='icon-bar' />
              </button>
            )}
            { conceptEngineActive && <a
              href={appSettings.get_app_url}
              className={buttonClasses}
              type='button'
              data-track-name={appSettings.track_name}
              data-track-value={pageName}
            >
              Get the App
            </a> }
            { !conceptEngineActive && <a className='navbar-brand navbar-hx-logo' href='/' data-hxtrack-name='navbar-logo'>Holiday Extras</a> }
            { conceptEngineActive && (
              <a href='/' data-hxtrack-name='navbar-logo-concept'>
                <div className='concept-logo pull-left' dangerouslySetInnerHTML={{__html: conceptLogo}} />
              </a>
            ) }
            { isHomepage && loggedInStatus && <div className='mobile-greeting visible-xs' dangerouslySetInnerHTML={{ __html: this.getGreeting(true) }} /> }
          </div>
          <div className={collapsedMenu}>
            <ul className='nav navbar-nav list-inline'>
              { !hideLinks && Object.keys(headerConfig).map(function (listGroup, key) {
                if (listGroup === 'search' || listGroup === 'blog' || discludeMenuItems.indexOf(listGroup) > -1) return null
                return (
                  <HeaderNav
                    key={key}
                    pageName={pageName}
                    handleClick={this.handleClick}
                    listGroup={listGroup}
                    active={activeTab}
                    linkData={headerConfig[listGroup]}
                  />
                )
              }.bind(this))}
              { !hideLinks && (
              <LoggedInUser ref='loggedInContainer' handleClick={this.handleClick} active={activeTab} loggedIn={loggedInData} showWelcomeBackMsg={showWelcomeBackMsg} welcomeBackMsgVisible={welcomeBackMsgVisible} closeWelcomeBackMsg={this.closeWelcomeBackMsg} />
                )}
              { !hideLinks && (
              <LoginNav domainSettings={domainSettings} loginConfig={loginConfig} ref='LoginNav' active={activeTab} settings={settings} authenticationConfig={authenticationConfig} handleClick={this.handleClick} pageName={pageName} visible={!loggedInStatus} />
                )}
              { !hideLinks && headerConfig.search && (
              <li className='form-search pull-right'>
                <a href={headerConfig.search.link} data-hxtrack-name='navbar-search'>{ headerConfig.search.placeHolder }</a>
              </li>
                )}
              { !hideLinks && showSearchForm && (
              <li className='searchForm hidden-sm'>
                <SearchForm
                  searchFormAction={headerConfig.search.action}
                  searchFormPlaceholder={headerConfig.search.placeHolder}
                    />
              </li>
                )}
              { phoneNumber && (
              <li className={phoneNumberClass}>
                <a href={`tel:${phoneNumber.replace(/ /g, '')}`} data-hxtrack-name='mobile-number'>{customPhoneText}<i className='icon-phone' />Call {phoneNumber}</a>
              </li>
                )}
            </ul>
            { !hideLinks && !includeAlerts && showStrapLineText && <h1 className='pull-left' dangerouslySetInnerHTML={{ __html: this.getGreeting() }} />}
          </div>
          { mobilePhoneBanner && (
            <div className='visible-xs text-center row alert alert-info alert-block' role='alert'>
              <span>Call FREE on </span>
              <a href={`tel:${phoneNumber}`} data-hxtrack-name='mobile-number'>
                <strong>{phoneNumber}</strong>
              </a>
            </div>
          )}
          { showWelcomeBackMsg && (
            <WelcomeBackMsg welcomeBackMsgVisible={welcomeBackMsgVisible} isOnMobile loggedInData={loggedInData} closeWelcomeBackMsg={this.closeWelcomeBackMsg} />
          )}
          { includeAlerts && (
            <div className={`flexItems${hideLinks ? ' noLinks' : ''}`}>
              <div className='clearfix flexItems'>
                { (bookingButton || showAppLink) && (
                  <div className='clearfix nav-cta-container'>
                    { bookingButton }
                    { showAppLink && !conceptEngineActive && (
                      <a
                        href={appSettings.get_app_url}
                        className={buttonClasses}
                        type='button'
                        data-track-name={appSettings.track_name}
                        data-track-value={pageName}
                      >
                        Get the App
                      </a>
                    ) }
                  </div>
                )}
                { showStrapLineText && showH1Tag && <h1 className={headingClass} dangerouslySetInnerHTML={{ __html: this.getGreeting() }} />}
                { showStrapLineText && !showH1Tag && <p className={headingClass} dangerouslySetInnerHTML={{ __html: this.getGreeting() }} />}
              </div>
              { !conceptEngineActive && <DiscountAlert
                pageName={pageData.pageName}
                settings={settings}
                translationConfig={alertsTranslationConfig}
                onShowHide={showHideDiscountBanner}
              /> }
              <HarpAlert settings={settings} onShowHide={showHideHarpBanner} />
            </div>
          )}
        </div>
      </nav>
    )
  }
}

Nav.propTypes = {
  pageData: object,
  domainSettings: object,
  phoneNumbers: object,
  headerConfig: object,
  authenticationConfig: object,
  hideLinks: bool,
  settings: object,
  loginConfig: object,
  showStrapLineText: string,
  tradeMark: bool,
  showBookingsButton: bool,
  noPersonalisation: bool,
  includeAlerts: bool,
  showSearchForm: bool,
  phoneNumberOverride: string,
  isHomepage: bool,
  showH1Tag: bool,
  phoneNumberText: string,
  mobilePhoneBanner: bool,
  discludeMenuItems: array,
  conceptEngineActive: bool,
  conceptEngineSettings: object,
  showHideDiscountBanner: func,
  showHideHarpBanner: func,
  showWelcomeBackMsg: bool
}
Nav.defaultProps = {
  showStrapLineText: '',
  showBookingsButton: false,
  noPersonalisation: false,
  includeAlerts: false,
  showSearchForm: false,
  tradeMark: false,
  isHomepage: false,
  showH1Tag: true,
  loggedInData: { bookingHistory: { } },
  mobilePhoneBanner: false,
  discludeMenuItems: [],
  conceptEngineActive: false,
  conceptEngineSettings: {},
  showHideDiscountBanner: () => {},
  showHideHarpBanner: () => {},
  showWelcomeBackMsg: false
}

export default ReduxStores(Nav, ['login'], true)
